import { Component, Input, OnInit } from '@angular/core';
import { RequestList, StatusButtons, WebserviceResponse } from "../../../../_shared/interfaces";
import { AlertService, IAlertType, OrdersStoreService, RequestsStoreService } from "../../../../_shared/services";
import {Router, RouterLink} from "@angular/router";
import {ClrLoadingModule, ClrLoadingState} from '@clr/angular';
import {CurrencyPipe, NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-job-details-requests',
  standalone: true,
  imports: [
    NgIf,
    NgForOf,
    RouterLink,
    ClrLoadingModule,
    CurrencyPipe
  ],
  templateUrl: './job-details-requests.component.html',
  styleUrl: './job-details-requests.component.sass'
})
export class JobDetailsRequestsComponent implements OnInit {
  requests: RequestList[] = [];
  projectid: string = '';
  loading: boolean = true;
  statusLabel = 'alert-info';
  statusText = '';
  createOrderState: ClrLoadingState = ClrLoadingState.DEFAULT;

  @Input() reqprid: string = '';
  @Input() reqposid: string = '';
  @Input() reqpartid: number = 0;
  @Input() jobid: number = 0;

  statusButtons: StatusButtons[] = [
    { state: 'open', display: 'Entwurf', label: 'alert-info', icon: 'info-circle'},
    { state: 'running', display: 'Abgeschickt', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'rejected', display: 'Abgelehnt', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'too expensive', display: 'Zu teuer', label: 'alert-info', icon: 'exclamation-circle'},
    { state: 'ignored', display: 'Ignoriert', label: 'alert-info', icon: 'check-circle'},
    { state: 'answered', display: 'Beantwortet', label: 'alert-info', icon: 'check-circle'},
    { state: 'favored', display: 'Auftrag', label: 'alert-success', icon: 'check-circle'},
  ];

  constructor(
    private reqss: RequestsStoreService,
    private ordss: OrdersStoreService,
    private alertDispatcher: AlertService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.loadRequestsPositions(this.reqprid, this.reqposid, this.reqpartid);
  }

  loadRequestsPositions(projectid: string, position: string, part: number) {
    let stati = "favored, answered";
    this.reqss.getRequestsPositions(projectid, 0, position, part, stati).subscribe({
      next: data1 => {
        if (!data1 || !data1.object || data1.object.length === 0) {
          this.alertDispatcher.alertConfig.message = 'Keine Requestdaten gefunden!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          return;
        }
        this.requests = data1.object;
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  createOrder(projectID: string, requestID: number, jobID: number){
    if (confirm('Wollen Sie für diese Anfrage einen Auftrag anlegen?')) {
      let orderID: number = 0;
      this.createOrderState = ClrLoadingState.LOADING;
      this.ordss.createOrder(projectID, requestID, jobID)
        .subscribe({
          next: (data: WebserviceResponse<boolean>) => {
            if (!data || data.hasErrors || !data.message) {
              this.alertDispatcher.alertConfig.message += ' Order konnte nicht erstellt werden! ';
              this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
              return;
            }
            orderID = Number(data.message);

            if (isNaN(orderID)) {
              this.alertDispatcher.alertConfig.message += ' Ungültige Bestätigungs-ID!';
              this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
              return;
            }
            this.alertDispatcher.alertConfig.message = 'Order wird erstellt...';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.INFO;
          },
          complete: () => {
            this.alertDispatcher.alertConfig.message = 'Order ' + projectID + '.0006.' + orderID + ' wurde angelegt!';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.SUCCESS;
            this.reqss.updateRequestStatus(projectID, requestID, 'favored')
              .subscribe({
                next: datax => {
                  this.createOrderState = ClrLoadingState.SUCCESS;
                },
                complete: () => {
                  this.router.navigate(['/order/details/', projectID, orderID]);
                },
                error: () => {
                }
              })
          },
          error: () => {
            this.alertDispatcher.alertConfig.message = 'Order konnte nicht angelegt werden.';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.DANGER;
            return
          }
        });
    }
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectstatus)
  };

  getCellStatus(status: string) {
    const statusline = this.findButtonStatus(status, this.statusButtons);
    return {
      'statusLabel': this.statusButtons[statusline].label,
      'statusDisplay': this.statusButtons[statusline].display,
      'statusIcon': this.statusButtons[statusline].icon
    };
  }

  findButtonClass(invoicestatus: string) {
    return "alert " + this.getCellStatus(invoicestatus).statusLabel + " alert-sm";
  }
}
